import { debounce } from '@mui/material'
import { useMemo, useRef } from 'react'

export default function useDebounce(func: () => void, time: number) {
  const ref = useRef(func)
  const debouncedCallback = useMemo(() => debounce(() => ref.current(), time), [])
  return { debouncedCallback, ref }
}
